import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { FacilityDetailsProvider } from 'contexts/FacilityDetailsContext'
import { FacilityConfigProvider } from 'contexts/FacilityConfigContext'
import ActionTrackerLoadsheet from 'pages/ActionManagement/ActionTrackerLoadsheet'
import { PermissionProvider } from 'contexts/PermissionContext'
import { AVP_SERVICE_ACTION_TRACKER } from 'constants/avp_permissions'

const AdminIndex = lazy(() => import('pages/Admin/Index'))
const AddProject = lazy(() => import('pages/Admin/AddProject'))
const SubprojectManagement = lazy(() => import('pages/Admin/SubprojectManagement'))
const SubprojectForm = lazy(() => import('pages/Admin/SubprojectForm'))

const HazardBarriersProjectsPage = lazy(
  () => import('pages/HazardBarrierEvaluation/HazardBarriersProjectsPage')
)
const ActionTrackerPage = lazy(() => import('pages/ActionManagement/ActionTrackerPage'))
const OEModuleSelector = lazy(
  () => import('pages/OEModuleSelector')
)
const UserPermissionConfig = lazy(() => import('pages/Permissions/UserPermissionConfig'))

const MainRoutes = (
  <>
    <Route path="/" element={<HazardBarriersProjectsPage />} />
    <Route path="/projects" element={<HazardBarriersProjectsPage />} />
    <Route path="/admin" element={<AdminIndex />} />
    <Route path="/admin/project/add" element={<AddProject />} />
    <Route path="/admin/project/:project_id/edit" element={<AddProject />} />
    <Route path="/admin/project/:project_id/subprojects" element={<SubprojectManagement />} />
    <Route path="/admin/project/:project_id/subprojects/add" element={<SubprojectForm />} />
    <Route path="/admin/project/:project_id/subprojects/:subproject_id/edit" element={<SubprojectForm />} />
    <Route
      path="/oe/project/:project_id"
      element={
        <FacilityDetailsProvider>
          <FacilityConfigProvider slug='project_feature_config' >
            <OEModuleSelector />
          </FacilityConfigProvider>
        </FacilityDetailsProvider>
      }
    />
    <Route
      path="/action-management/project/:project_id/"
      element={
        <FacilityDetailsProvider>
          <FacilityConfigProvider slug='project_feature_config' >
            <ActionTrackerPage />
          </FacilityConfigProvider>
        </FacilityDetailsProvider>
      }
    />

    <Route
      path="/action-management/project/:project_id/asset/:asset_id/:source/action-loadsheet"
      element={
        <PermissionProvider serviceName={AVP_SERVICE_ACTION_TRACKER}>
        <FacilityDetailsProvider>
          <FacilityConfigProvider slug='project_feature_config' >
            <ActionTrackerLoadsheet />
          </FacilityConfigProvider>
        </FacilityDetailsProvider>
        </PermissionProvider>
      }
    />

    <Route
      path="/action-management/project/:project_id/:source/action-loadsheet"
      element={
        <FacilityDetailsProvider>
          <FacilityConfigProvider slug='project_feature_config' >
            <ActionTrackerLoadsheet />
          </FacilityConfigProvider>
        </FacilityDetailsProvider>
      }
    />

    <Route path="/configuration/user-permission-config" element={<UserPermissionConfig />} />
  </>
)

export default MainRoutes
